import VisualSearchButton from 'components/VisualSearch'
import React from 'react'
import styles from './SearchInput.module.scss'

// TODO search v2 for most popular searches
const SearchMenuContent = () => {
  return (
    <div className={styles.searchDropdownBox}>
      <VisualSearchButton />
    </div>
  )
}

export default SearchMenuContent
